export const COMMERCIAL_GET_REQUEST = "COMMERCIAL_GET_REQUEST";
export const COMMERCIAL_GET_SUCCESS = "COMMERCIAL_GET_SUCCESS";
export const COMMERCIAL_GET_FAILURE = "COMMERCIAL_GET_FAILURE";